import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/arrow-forward.svg'


const _withScopeId = n => (_pushScopeId("data-v-4c5a451f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "div-heading-left" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "div-category-icon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["id", "innerHTML"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "div-arrow-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon-darker",
    src: _imports_0
  })
], -1))
const _hoisted_11 = ["id"]
const _hoisted_12 = {
  key: 0,
  class: "div-dot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "div-main",
    id: `service-category-card-div-main-${_ctx.serviceCategoryType}`,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectedCategory && _ctx.selectedCategory(...args)))
  }, [
    _createElementVNode("div", {
      class: "div-heading",
      id: `service-category-card-div-heading-${_ctx.serviceCategoryType}`
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "div-heading-inner",
          id: `service-category-card-div-heading-inner-${_ctx.serviceCategoryType}`
        }, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.validServiceCategoryTypeFound())
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "img-category-icon",
                  src: `${_ctx.getIcon()}`
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("h3", {
            id: `service-category-heading-${_ctx.serviceCategoryType}`,
            innerHTML: _ctx.heading
          }, null, 8, _hoisted_7)
        ], 8, _hoisted_4),
        (_ctx.options.length === 1)
          ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(_ctx.options.length) + " " + _toDisplayString(_ctx.store.getters.translate("service-categories-card-single-service")), 1))
          : (_ctx.options.length > 1)
            ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.options.length) + " " + _toDisplayString(_ctx.store.getters.translate("service-categories-card-multiple-services")), 1))
            : _createCommentVNode("", true)
      ]),
      _hoisted_10
    ], 8, _hoisted_2),
    (_ctx.options.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "div-content",
          id: `service-category-card-div-content-${_ctx.serviceCategoryType}`
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (opt, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "div-options"
            }, [
              _createElementVNode("p", null, _toDisplayString(_ctx.options[index]), 1),
              (index + 1 < _ctx.options.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ], 8, _hoisted_11))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}